import React from 'react';
import CreatableSelect from 'react-select/lib/Creatable';
import Menu from './Menu';
import setStyle from './setSytle';
import { setDefaultValue } from './setDefaultValue';

const DefaultSelect = (props) => {
    const {
        value, options, color, isClearable, colorToSelectedOption,
        fontWeight, transformOrigin, menuLeft,
        menuTop, menuBottom, border, fontColor, menuHeight, minWidth, components,
        whiteSpace, background, fontSize, fontFamily, isAnimated, isDisabled,
    } = props;

    return (
        <CreatableSelect
            {...props}
            value={setDefaultValue(value, options)}
            styles={
                setStyle(
                    color,
                    isClearable,
                    colorToSelectedOption,
                    fontWeight,
                    border,
                    fontColor,
                    menuHeight,
                    minWidth,
                    whiteSpace,
                    background,
                    fontSize,
                    fontFamily,
                )
            }
            components={{
                Menu: innerProps => (
                    <Menu
                        innerProps={innerProps}
                        transformOrigin={transformOrigin}
                        position={
                            {
                                left: menuLeft, top: menuTop, bottom: menuBottom, isAnimated,
                            }
                        }
                    />
                ),
                ...components,
            }}
        />
    );
};

DefaultSelect.defaultProps = {
    border: null,
    color: '#fff',
    colorToSelectedOption: null,
    components: null,
    value: null,
    fontColor: '#555555',
    fontWeight: 'normal',
    isClearable: false,
    menuBottom: 'auto',
    menuLeft: 0,
    menuTop: 34,
    menuHeight: '300px',
    menuWidth: '100%',
    minWidth: 'auto',
    onCreateOption: x => x,
    switchAnimation: false,
    transformOrigin: 'left bottom',
    isDisabled: false,
};


export default DefaultSelect;
